import { render, staticRenderFns } from "./RoomKitchen.vue?vue&type=template&id=55829d59&scoped=true"
import script from "./RoomKitchen.vue?vue&type=script&lang=ts"
export * from "./RoomKitchen.vue?vue&type=script&lang=ts"
import style0 from "./RoomKitchen.vue?vue&type=style&index=0&id=55829d59&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55829d59",
  null
  
)

export default component.exports